import {Directive, Renderer2, ElementRef, Output, EventEmitter, OnDestroy, Input, Inject, OnInit,} from "@angular/core";
import {
	WINDOW_LISTENER_TOKEN, WindowEvent,
	WindowHostListenerService
} from "../../../window/window.host.listener.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Directive({
	selector: '[cpClickOut]',
})
export class ClickOutDirective implements OnInit, OnDestroy{

	@Input() clickOutDisable: boolean;
	@Input() closeTargetNotOnDom: boolean;
	@Input() closeOnScroll: boolean = true;
	@Input() closeOnDrag: boolean = false;
	@Input() useCapture: boolean = true;
	@Input() closeOnContextMenu: boolean = false;
	@Input() ignoreKendoCalendarClicks=false;
	@Input() ignoreKendoPopOverClick=false;

	@Output() clickOut = new EventEmitter();

	public currentClick = true;

	// we keep this using a specific implementation to help with performance otherwise it tuns a lot
	// of times during drap operations. this is imporant for the nav-bar
	private listeningOnDrag:boolean;

	constructor(public renderer: Renderer2, public elementRef: ElementRef,
				@Inject(WINDOW_LISTENER_TOKEN ) private windowHostListenerService: WindowHostListenerService) {
	}

	public ngOnChanges(){
		if (this.closeOnDrag && !this.listeningOnDrag) {
			this.listeningOnDrag=true;
			this.windowHostListenerService.getObservable(WindowEvent.drag)
				.pipe(untilDestroyed(this))
				.subscribe((event) => this.onClick(event));
		}
	}

	public ngOnInit(): void {
		this.windowHostListenerService.getObservable(WindowEvent.click, this.useCapture)
			.pipe(untilDestroyed(this))
			.subscribe((event) => this.onClick(event));

		//For touch screen
		this.windowHostListenerService.getObservable(WindowEvent.touchend, this.useCapture)
			.pipe(untilDestroyed(this))
			.subscribe((event) => this.onClick(event));

		if (this.closeOnScroll) {
			this.windowHostListenerService.getObservable(WindowEvent.scroll)
				.pipe(untilDestroyed(this))
				.subscribe((event) => this.onClick(event));
		}

		if (this.closeOnContextMenu) {
			this.windowHostListenerService.getObservable(WindowEvent.contextmenu)
				.pipe(untilDestroyed(this))
				.subscribe((event) => this.onClick(event));
		}

		setTimeout(() => this.currentClick = false, 0);
	}


	public ngOnDestroy(): void {
	}

	public onClick(event) {
		if (!this.clickOutDisable && !this.currentClick
			&& (document.body.contains(event.target) || this.closeTargetNotOnDom)
			&& !this.elementRef.nativeElement.contains(event.target)
			&& (!this.ignoreKendoPopOverClick ||
				(this.ignoreKendoPopOverClick && !this.checkIfParentIsOfType(event.target,"KENDO-POPOVER")))
			&& (!this.ignoreKendoCalendarClicks ||
				(this.ignoreKendoCalendarClicks && !this.checkIfParentIsOfType(event.target,"KENDO-CALENDAR")))
			&& (!event.target.hasAttribute || (event.target.hasAttribute && !event.target.hasAttribute('kendodropdownsselectable')))
		) {
			this.clickOut.emit(event);
		}
	}


	private checkIfParentIsOfType(htmlElement:HTMLElement, searchForType:string){
		while (htmlElement && htmlElement.parentElement){
			if (htmlElement.parentElement.tagName===searchForType){
				return true;
			}
			htmlElement=htmlElement.parentElement;
		}
		return false;
	}
}
